import type { CreatorOnboardingStep } from "@/api/creatorOnboarding";

export const OPEN_CREATOR_ONBOARDING_EVENT = "creator-onboarding:open";
export const CREATOR_PAYMENT_PROFILE_UPDATED_EVENT = "creator-payment-profile:updated";

export type OpenCreatorOnboardingEvent = CustomEvent<{ step?: CreatorOnboardingStep }>;

export const openCreatorOnboarding = (step?: CreatorOnboardingStep): void => {
	window.dispatchEvent(
		new CustomEvent(OPEN_CREATOR_ONBOARDING_EVENT, {
			detail: { step },
		}),
	);
};

export const notifyCreatorPaymentProfileUpdated = (): void => {
	window.dispatchEvent(new Event(CREATOR_PAYMENT_PROFILE_UPDATED_EVENT));
};
